// extracted by mini-css-extract-plugin
module.exports = {"dropDown":"index_dropDown__1gmbs","dropDownLight":"index_dropDownLight__uKe-m","spanlight_hover":"index_spanlight_hover__3vdBg"};